<script setup lang="ts">
const props = defineProps<{
    alertSettings: IAlert;
}>();

// TODO: Figure out why css animation does not reset

const emit = defineEmits<{
    'hide-alert': [];
}>();
const INITIAL_DURATION = props.alertSettings.duration;
const animationDuration = ref<number>(INITIAL_DURATION);
let timer: ReturnType<typeof setTimeout> | undefined = undefined;

onUpdated(() => {
    if (props.alertSettings?.isVisible) {
        if (typeof timer !== 'undefined') {
            clearTimeout(timer);
            animationDuration.value = INITIAL_DURATION;
        }
        timer = setTimeout(() => {
            emit('hide-alert');
        }, animationDuration.value);
    }
});
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
    <div
        v-if="alertSettings.isVisible"
        role="alert"
        aria-live="polite"
        class="arl-alert"
        :class="`arl-alert-${alertSettings.type}`">
        <div class="arl-alert__content">
            <SvgComponent :icon="alertSettings.type" />
            <template v-if="typeof alertSettings.messages === 'string'">
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div class="alert-item" v-html="alertSettings.messages" />
            </template>
            <template v-else>
                <!-- eslint-disable vue/no-v-html -->
                <div
                    v-for="(error, index) in alertSettings.messages"
                    :key="`error-${index}`"
                    class="arl-alert-item"
                    v-html="error" />
                <!-- eslint-enable vue/no-v-html -->
            </template>
        </div>
        <!-- <div class="arl-alert__progress arl-alert__progress--active" /> -->
    </div>
</template>

<style lang="css">
@reference "~/assets/css/main.css";

.arl-alert {
    @apply fixed bottom-6 left-1/2 z-50 w-fit -translate-x-1/2 overflow-hidden rounded-md bg-white/90 px-4 py-3 shadow-lg backdrop-blur-lg;
}

.arl-alert__content {
    @apply flex items-center gap-1;
}

.arl-alert-error {
    @apply border-functional-error text-functional-error border bg-white;
}

.arl-alert-warning {
    @apply border-functional-warning text-functional-warning border bg-white;
}

.arl-alert-info {
    @apply border-functional-information text-functional-information border;
}

.arl-alert-success {
    @apply border-functional-success text-functional-success border;
}

.arl-alert__progress {
    @apply absolute bottom-0 left-0 h-1 w-full before:absolute before:bottom-0 before:left-0 before:h-full before:w-[0%] before:bg-white;
}

.arl-alert__progress.arl-alert__progress--active::before {
    animation: keyprogress v-bind(`${animationDuration}ms`) linear forwards;
    background-color: currentColor;
}

@keyframes keyprogress {
    to {
        width: 100%;
    }
}

.fadeslide-up-enter-active,
.fadeslide-up-leave-active {
    transition: all 0.3s ease;
}

.fadeslide-up-enter-from,
.fadeslide-up-leave-to {
    transform: translate(0, 100%);
    opacity: 0;
}
</style>
